<script lang="ts">
  import Rotation from './Rotation.svelte'
  import Size from './Size.svelte'
  import ForbiddenZoneHeight from './ForbiddenZoneHeight.svelte'
  import { Object3D, type Object3DEventMap } from 'three'
  import Translation from './Translation.svelte'
  import i18n from '../../../../../i18n'
  import SectionContainer from '../SectionContainer.svelte'
  import { ThreeItemKeys } from '../../../../../constants/three'
  import Separator from '../../../../../components/separator/Separator.svelte'
  import useCanvasSelection from '../../../../../hooks/canvas-selection'
  import Button from '../../../../../components/button/Button.svelte'
  import { dropObjectToFloor } from '../../../../../helpers/drop-to-floor'
  import useObjectQueries from '../../../hooks/useObjectQueries'
  import { ArrowDownToLine } from '@lucide/svelte'

  const { object }: { object: Object3D<Object3DEventMap> } = $props()
  const { hasSingleForbiddenZone, hasSingleGroup, hasSingleFile } = useCanvasSelection()
  const { invalidateCanvas } = useObjectQueries()

  function handleDropToFloor() {
    dropObjectToFloor(object)
    invalidateCanvas()
  }
</script>

<SectionContainer title={$i18n.t('project.rightBar.position.title')}>
  <div class="row">
    <Translation {object} />
    <Rotation {object} />
  </div>
  {#if hasSingleGroup() || hasSingleFile()}
    <Button
      class="drop-to-floor-button"
      onclick={handleDropToFloor}
      size="sm"
      variant="secondary"
    >
      {$i18n.t('project.rightBar.position.dropToFloor')}
      <ArrowDownToLine />
    </Button>
  {/if}
</SectionContainer>
{#if hasSingleForbiddenZone()}
  <Separator />
  {#if object.userData[ThreeItemKeys.FORBIDDEN_ZONE_POINTS]}
    <SectionContainer title={$i18n.t('project.rightBar.forbiddenZone.title')}>
      <ForbiddenZoneHeight {object} />
    </SectionContainer>
  {:else}
    <SectionContainer title={$i18n.t('project.rightBar.size.title')}>
      <Size {object} />
    </SectionContainer>
  {/if}
{/if}

<style lang="scss">
  .row {
    display: flex;
    gap: 0.5rem;

    :global(.ghost-button) {
      width: 100%;
      padding-left: 0;
      justify-content: start;
      font-size: 0.75rem;

      &:hover {
        background-color: transparent;
      }
    }
  }

  :global(.drop-to-floor-button) {
    width: 100%;
    margin-top: 0.75rem;
  }
</style>
